import { useState, useEffect, useCallback } from 'react';
import api from '../services/api';

export function useDeliveries(cityId) {
  const [deliverers, setDeliverers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchDeliverers = useCallback(async () => {
    if (!cityId) return;
    setLoading(true);
    setError(null);
    try {
      const { data } = await api.get('/deliveries', { params: { city_id: cityId } });
      const list = data.deliverers || data.data || (Array.isArray(data) ? data : []);
      setDeliverers(list);
    } catch (err) {
      setError(err.response?.data?.error?.message || 'Erro ao carregar entregadores');
      setDeliverers([]);
    } finally {
      setLoading(false);
    }
  }, [cityId]);

  useEffect(() => {
    if (cityId) fetchDeliverers();
  }, [cityId, fetchDeliverers]);

  return { deliverers, loading, error, refetch: fetchDeliverers };
}
